import React, { useEffect, useState } from 'react';
import Autocomplete from '@mui/material/Autocomplete';
import { configData } from "../config";
import { hasStaffBlocks } from './QuickLinks';
import './classes/ApplicantAgentSearch.css';

// The live site's "Applicant & Agent Search" block at the bottom of the right column of the pages
// with the general quick form (degree pages, course pages outside /courses, conference pages), of
// the Courses and Conferences pages and of the course pages under /courses, for signed-in staff
// (hasStaffBlocks):
// a plain text box that looks up applicants and agents as the staff sidebar's search does
// (SalespersonSidebar, user/getapplicationuserlist) and opens the one picked.
const ApplicantAgentSearch = ({ roles }) => {
    const [searchValue, setSearchValue] = useState('');
    const [options, setOptions] = useState([]);

    useEffect(() => {
        if (searchValue.trim() === '') {
            setOptions([]);
            return;
        }
        // Look up once typing pauses
        const handler = setTimeout(async () => {
            try {
                const response = await fetch(configData.APP_URL + 'user/getapplicationuserlist?query=' + encodeURIComponent(searchValue));
                const data = await response.json();
                setOptions(Array.isArray(data?.data?.result) ? data.data.result : []);
            } catch (error) {
                console.error('Error fetching data:', error);
            }
        }, 500);
        return () => clearTimeout(handler);
    }, [searchValue]);

    if (!hasStaffBlocks(roles)) return null;
    return (
        // Headed like the Success Stories block above it
        <div className="course-success-box applicant-search-block">
            <h2 className="success-title">Applicant & Agent Search</h2>
            {/* freeSolo: no "No options" box under an empty or unmatched search, as on the live site */}
            <Autocomplete
                id="applicant_agent_search"
                freeSolo
                options={options}
                filterOptions={(x) => x}
                getOptionLabel={(option) => (typeof option === 'string' ? option : option.label || '')}
                onInputChange={(event, value, reason) => {
                    if (reason === 'input') setSearchValue(value);
                }}
                onChange={(event, option) => {
                    if (option?.link) window.location.href = option.link;
                }}
                renderOption={(props, option) => {
                    const { key, ...optionProps } = props;
                    return (
                        <li key={key} {...optionProps}>
                            <a href={option.link}>{option.label}</a>
                        </li>
                    );
                }}
                renderInput={(params) => (
                    <div ref={params.InputProps.ref}>
                        <input type="text" {...params.inputProps} />
                    </div>
                )}
            />
        </div>
    );
};

export default ApplicantAgentSearch;
